__turbopack_context__.v({
  "content": "aiSidebar-module-scss-module__PWgSkq__content",
  "contentFadeIn": "aiSidebar-module-scss-module__PWgSkq__contentFadeIn",
  "header": "aiSidebar-module-scss-module__PWgSkq__header",
  "history": "aiSidebar-module-scss-module__PWgSkq__history",
  "inner": "aiSidebar-module-scss-module__PWgSkq__inner",
  "innerWithHistory": "aiSidebar-module-scss-module__PWgSkq__innerWithHistory",
  "instant": "aiSidebar-module-scss-module__PWgSkq__instant",
  "overlay": "aiSidebar-module-scss-module__PWgSkq__overlay",
  "sidebar": "aiSidebar-module-scss-module__PWgSkq__sidebar",
});
